module.exports = __webpack_public_path__ + "img/buy_usdt_mobile1.3ed20918.png";